import React from "react";
import { observer } from "mobx-react";
import { VatStatusViewStore } from "../../store";
import { VatStatusViewForm } from "./VatStatusViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type VatStatusViewProps = {
  vatStatusViewStore: VatStatusViewStore;
};

export const VatStatusView: React.FC<VatStatusViewProps> = observer(
  ({ vatStatusViewStore }) => {
    return (
      <div>
        <VatStatusViewForm
          name_es={vatStatusViewStore.name_esValue}
          name_en={vatStatusViewStore.name_enValue}
          name_pt={vatStatusViewStore.name_ptValue}
          description_es={vatStatusViewStore.description_esValue}
          description_en={vatStatusViewStore.description_enValue}
          description_pt={vatStatusViewStore.description_ptValue}
          onPrint={(handlePrint: () => void) =>
            vatStatusViewStore.printVatStatus(handlePrint)
          }
          onCancel={() => vatStatusViewStore.cancelVatStatus()}
          onEdit={
            vatStatusViewStore.isEditEnabled
              ? () => vatStatusViewStore.editVatStatus()
              : undefined
          }
        />
        <ErrorDialog
          open={vatStatusViewStore.errorDialogOpened}
          title={vatStatusViewStore.errorTitle}
          description={vatStatusViewStore.errorDescription}
          onClose={() => vatStatusViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
